const UI_START_LOADING = "loader/UI_START_LOADING";
const UI_STOP_LOADING = "loader/UI_STOP_LOADING";

export { UI_START_LOADING, UI_STOP_LOADING };
